// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.footer{
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    gap: 50px;

}
.footer-logo{
    display: flex;
    align-items: center;
    gap: 20px;

}
.footer-logo p{
    color: #383838;
    font-size: 46px;
    font-weight: 700;
}
.footer-links{
    display: flex;
    list-style: none;
    gap: 50px;
    color: #252525;
    font-size: 20px;
    
}
.footer-links li{
    cursor: pointer;
}
.footer-social-icon{
    display: flex;
    gap: 20px;
}
.footer-icons-container{
    padding: 10px;
    padding-bottom: 6px;
    background: #fbfbfb;
    border: 1px solid #ebebeb;
}
.footer-copyright{
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 30px;
    width: 100%;
    margin-bottom: 30px;
    color: #1a1a1a;
    font-size: 20px;
}
.footer-copyright hr{
    width: 80%;
    border: none;
    border-radius: 10px;
    height: 3px;
    background: #c7c7c7;
}
@media(max-width:800px){
    .footer{
        gap: 20px;
    }
    .footer-logo{
        gap: 10px;
        align-items: end;
    }
    .footer-logo img{
        width: 40px;

    }
    .footer-logo p{
        font-size: 25px;
    }
    .footer-links{
        font-size: 14px;
        gap: 10px;
    }
    .footer-social-icon img{
        width: 22px;
    }
    .footer-copyright{
        font-size: 13px;
    }
}`, "",{"version":3,"sources":["webpack://./src/Components/Footer/Footer.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,sBAAsB;IACtB,uBAAuB;IACvB,mBAAmB;IACnB,SAAS;;AAEb;AACA;IACI,aAAa;IACb,mBAAmB;IACnB,SAAS;;AAEb;AACA;IACI,cAAc;IACd,eAAe;IACf,gBAAgB;AACpB;AACA;IACI,aAAa;IACb,gBAAgB;IAChB,SAAS;IACT,cAAc;IACd,eAAe;;AAEnB;AACA;IACI,eAAe;AACnB;AACA;IACI,aAAa;IACb,SAAS;AACb;AACA;IACI,aAAa;IACb,mBAAmB;IACnB,mBAAmB;IACnB,yBAAyB;AAC7B;AACA;IACI,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,SAAS;IACT,WAAW;IACX,mBAAmB;IACnB,cAAc;IACd,eAAe;AACnB;AACA;IACI,UAAU;IACV,YAAY;IACZ,mBAAmB;IACnB,WAAW;IACX,mBAAmB;AACvB;AACA;IACI;QACI,SAAS;IACb;IACA;QACI,SAAS;QACT,gBAAgB;IACpB;IACA;QACI,WAAW;;IAEf;IACA;QACI,eAAe;IACnB;IACA;QACI,eAAe;QACf,SAAS;IACb;IACA;QACI,WAAW;IACf;IACA;QACI,eAAe;IACnB;AACJ","sourcesContent":[".footer{\n    display: flex;\n    flex-direction: column;\n    justify-content: center;\n    align-items: center;\n    gap: 50px;\n\n}\n.footer-logo{\n    display: flex;\n    align-items: center;\n    gap: 20px;\n\n}\n.footer-logo p{\n    color: #383838;\n    font-size: 46px;\n    font-weight: 700;\n}\n.footer-links{\n    display: flex;\n    list-style: none;\n    gap: 50px;\n    color: #252525;\n    font-size: 20px;\n    \n}\n.footer-links li{\n    cursor: pointer;\n}\n.footer-social-icon{\n    display: flex;\n    gap: 20px;\n}\n.footer-icons-container{\n    padding: 10px;\n    padding-bottom: 6px;\n    background: #fbfbfb;\n    border: 1px solid #ebebeb;\n}\n.footer-copyright{\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    gap: 30px;\n    width: 100%;\n    margin-bottom: 30px;\n    color: #1a1a1a;\n    font-size: 20px;\n}\n.footer-copyright hr{\n    width: 80%;\n    border: none;\n    border-radius: 10px;\n    height: 3px;\n    background: #c7c7c7;\n}\n@media(max-width:800px){\n    .footer{\n        gap: 20px;\n    }\n    .footer-logo{\n        gap: 10px;\n        align-items: end;\n    }\n    .footer-logo img{\n        width: 40px;\n\n    }\n    .footer-logo p{\n        font-size: 25px;\n    }\n    .footer-links{\n        font-size: 14px;\n        gap: 10px;\n    }\n    .footer-social-icon img{\n        width: 22px;\n    }\n    .footer-copyright{\n        font-size: 13px;\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
